export default {
  CHANGE_BOARD: 'CHANGE_BOARD',
  CHANGE_PIECE: 'CHANGE_PIECE',
  CHANGE_MODE: 'CHANGE_MODE',
  LOGIN_USER: 'LOGIN_USER_SUCCESS',
  LOG_OUT: 'LOG_OUT',
  UPDATE_MOVES: 'UPDATE_MOVES',
  STATUS_TEXT: 'STATUS_TEXT',
  DEFAULT_BOARD_SETTINGS: 'DEFAULT_BOARD_SETTINGS',
};
